import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
/**
 * Partner prefill additional info
 */
export const PrefillAdditionalInfoStep: Step = {
  id: 'prefilladditionalinfo',
  pathname: '/prefilladditionalinfo',
  canShow: (appData: AppData) => {
    return !!appData.featureData?.prefillQuotingVariation;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.name && !!appData.phone, // TODO: check all fields has value
  category: () => StepCategory.AdditionalInfo,
};
